// Import packages
import React from "react";
import {useLocation} from "react-router-dom";

// Import Styles
import '../../assets/styles/cards/list-card.scss';

// Import components
import {LinkButton} from "../buttons/buttons";
import {MaterialIcon} from "../utils/Icon";
import {Checkbox, Tooltip} from "antd";
import {history} from "../../configs/history";
import {setPageOffset} from "../../redux/actions";

function ListItemCard(props) {
    const {
        data, status, actions, largeItems, largeItemsWidth, smallItemsWidth, detailsLink, editLink,
        selectingActive, getScrollPosition, generalInfoWith
    } = props;
    let location = useLocation();

    function onClick() {
        if (getScrollPosition) {
            const offset = getScrollPosition?.();
            // console.log(offset);
            const pageName = location.pathname.split('/')?.[1];
            setPageOffset({
                offset,
                pageName,
            })
        }
        history.push({
            pathname: `/${detailsLink}/${data.nestedItemId || data.id}`,
        })
    }

    function onClickValueItem(e, redirect) {
        e.preventDefault();
        e.stopPropagation();
        if (getScrollPosition) {
            const offset = getScrollPosition?.();
            // console.log(offset);
            const pageName = location.pathname.split('/')?.[1];
            setPageOffset({
                offset,
                pageName,
            })
        }
        redirect && history.push({
            pathname: redirect
        })
    }

    return <div className={`list-item-wrapper ${data?.newItem ? 'selected' : ''} ${data?.bordered ? 'bordered' : ''}`}
                onClick={data?.onClick}>
        {selectingActive && <span className={'selecting-checkbox'}>
                <Checkbox checked={data?.selected} onChange={data?.handleSelect}/>
            </span>}
        <div className={`general-info-content ${status ? "with-status" : ""}`} onClick={detailsLink && onClick}>
            {data?.values && !!data.values.length && data.values.map((item, index) => {
                const redirectedValue = typeof item === 'object' && item?.redirect;
                const width = largeItems.includes(index)
                    ? largeItemsWidth
                    : smallItemsWidth;
                const maxWidth = generalInfoWith * width / 100;

                return <span
                    onClick={(e) => redirectedValue && onClickValueItem(e, item?.redirect)}
                    className={`general-info-item ${redirectedValue ? 'hovered' : ''}`}
                    style={{width: `${width}%`, maxWidth: `${maxWidth}px`,}}
                    key={index}>
                            {(typeof item === 'object' && item?.twoRow) && <div className={'two-row'}>
                                <span>{item?.title}</span>
                                <span>{item?.subTitle}</span>
                            </div>}
                    {(typeof item === 'object' && !item?.twoRow) &&
                        (item?.tooltip ? <Tooltip placement="bottomLeft"
                                                  title={item?.title}>
                            {item?.title}
                        </Tooltip> : item?.title)
                    }
                    {typeof item !== 'object' && item}
                        </span>
            })}
        </div>
        <div className="item-actions-part">
            {status && <>
                {
                    typeof data?.status === 'boolean' ?
                        <div className="status">{data?.status ? 'Ակտիվ' : 'Ոչ ակտիվ'}</div>
                        : <span className={`status-badge`}
                                style={{backgroundColor: data?.status?.color + '14', color: data?.status?.color}}>
                    {data.status?.title}</span>
                }
            </>
            }
            {actions && <div className="actions">
                {!!actions.length && actions.map((item) => {
                    return (item === "edit" && editLink) ?
                        <LinkButton link={{pathname: `${editLink}/${data.id}`}}
                                    key={item}
                                    className={"edit-button"}
                                    title={<MaterialIcon icon="edit"/>}/>

                        : (item === "send" && data.openModalCb) ?
                            <Checkbox className="round"
                                      checked={data.selected}
                                      onChange={data.openModalCb}/> :

                            ((item === "delete" && data.deleteCb) ?
                                <LinkButton key={item}
                                            title={<MaterialIcon icon="delete"/>}
                                            className="bg-red"
                                            cb={data.deleteCb}/>
                                : ((item === "details" && detailsLink) ?
                                    <LinkButton link={{
                                        pathname: `/${detailsLink}/${data.id}`
                                    }} key={item} title={<MaterialIcon
                                        icon="keyboard_arrow_right"/>}/> : ""))
                })}
            </div>}
        </div>
    </div>

}

export default ListItemCard
